<template>

    <div class="full-bg-image"
         style="background-image: url('/images/science_color.png'); background-size: 300px; background-repeat:repeat">
        <div class="row justify-content-center h-100 pt-4">
            <div class="card h-100 w-100" style="border-radius: 0; max-width: 1024px;">
                <div class="card-body" style="padding: 2rem">

                    <div class="form">

                        <div class="form-group">
                            <h4 class="text-xl font-">Debit Order Authorization</h4>
                        </div>

                        <div class="form-group mt-4">
                            <label class="font-weight-bold">RedRabbit Details</label>
                            <table class="table">
                                <thead>
                                <tr>
                                    <th style="width: 25%"></th>
                                    <th style="width: 75%"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Abbreviated Name</td>
                                    <td>{{settings.abbreviated_name}} (as registered with the bank)</td>
                                </tr>
                                <tr>
                                    <td>Selected Plan</td>
                                    <td>{{getFormattedSubscriptionPlanName()}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="form-group mt-4">
                            <label class="font-weight-bold">Company Details</label>
                            <table class="table">
                                <thead>
                                <tr>
                                    <th style="width: 25%"></th>
                                    <th style="width: 75%"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Contract Date</td>
                                    <td>{{app.moment | date}}</td>
                                </tr>
                                <tr>
                                    <td>Contract Reference</td>
                                    <td>{{settings.contract_reference}}</td>
                                </tr>
                                <tr v-if="settings.company_name">
                                    <td>Company Name</td>
                                    <td>{{settings.company_name}}</td>
                                </tr>
                                <tr>
                                    <td>Trading Name</td>
                                    <td>{{settings.trading_name}}</td>
                                </tr>
                                <tr v-if="settings.registration_number">
                                    <td>Registration/ID NR</td>
                                    <td>{{settings.registration_number}}</td>
                                </tr>
                                <tr v-if="settings.phone">
                                    <td>Phone</td>
                                    <td>{{settings.phone}}</td>
                                </tr>
                                <tr v-if="settings.email">
                                    <td>Email</td>
                                    <td>{{settings.email}}</td>
                                </tr>
                                <tr>
                                    <td>Billing Address</td>
                                    <td>{{settings.billing_address}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="form-group mt-4">
                            <label class="font-weight-bold">Banking Details</label>
                            <table class="table">
                                <thead>
                                <tr>
                                    <th style="width: 25%"></th>
                                    <th style="width: 75%"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Account Name</td>
                                    <td>{{settings.bank_account_name}}</td>
                                </tr>
                                <tr>
                                    <td>Bank Name</td>
                                    <td>{{settings.bank_name}}</td>
                                </tr>
                                <tr>
                                    <td>Branch Code</td>
                                    <td>{{settings.bank_branch_code}}</td>
                                </tr>
                                <tr>
                                    <td>Account Number</td>
                                    <td>{{settings.bank_account_number}}</td>
                                </tr>
                                <tr>
                                    <td>Type</td>
                                    <td>{{settings.account_type}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="form-group mt-4">
                            <label class="font-weight-bold">Debit Order Details</label>
                            <table class="table">
                                <thead>
                                <tr>
                                    <th style="width: 25%"></th>
                                    <th style="width: 75%"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>{{ isUpgrading ? 'Next' : 'First'}} Collection Date</td>
                                    <td>{{ firstCollectionDate }}</td>
                                </tr>
                                <tr v-if="!isUpgrading">
                                    <td>Pro rata subscription amount until first collection</td>
                                    <td>{{settings.currency}} {{settings.first_collection_total}} <br>
                                        <small>To be collected with first debit order on {{firstCollectionDate}}</small>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Monthly License ({{settings.subscription_users}} User/s)</td>
                                    <td>{{settings.currency}} {{settings.subscription_amount}} per
                                        month
                                    </td>
                                </tr>
                                <tr v-if="settings.pricing_plan !== 'limited'">
                                    <td>Additional Users (Variable)</td>
                                    <td>
                                        {{settings.additional_users}} @ {{settings.currency}}
                                        {{settings.additional_user_subscription_amount}} per user per month
                                    </td>
                                </tr>
                                <tr>
                                    <td>SMS Credits (Variable)</td>
                                    <td>
                                        {{smsCost | noDecimals}} cents per sms credit used
                                    </td>
                                </tr>
                                <tr>
                                    <td>Escalation</td>
                                    <td>{{settings.escalation_percentage * 100}}% on {{escalationDate}}
                                        every year
                                        <p>
                                            <small>
                                                Your monthly subscription fee will never increase with more than this
                                                percentage and will always be less than or equal to the current market
                                                price.
                                            </small>
                                        </p>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="form-group mt-4">
                            <label class="font-weight-bold text-lg">Debit Order Authorization</label>
                            <p class="mb-5">
                                I/We confirm that the detail included above are correct and hereby apply to subscribe to
                                use the RedRabbit Solutions (Pty) Ltd hosted application
                                (RedRabbit.zone). I/We confirm that I/We have read the RedRabbit.zone Subscription
                                Agreement and that I/We hereby unconditionally
                                accept and agree to the Terms and Conditions included in the foresaid Subscription
                                Agreement.
                            </p>
                            <p class="mb-5">
                                I/We hereby authorize RedRabbit.zone to issue and deliver payment instructions to your
                                banker for collection against my/our above mentioned
                                account at my/our above mentioned bank on condition that the sum of such payment
                                instructions will not differ from my/our obligations
                                as agreed to in the Contract. The individual payment instructions so authorized must be
                                issued and delivered on the date when the
                                obligation in terms of the Agreement is due and the amount of each individual payment
                                instruction may not differ as agreed to in terms of
                                the Agreement.
                            </p>
                            <p class="mb-5">
                                The payment instructions so authorized to be issued must carry the Contract Reference
                                Number, included in the said payment instructions
                                and must be provided to identify the specific contract. The said Contract Reference
                                Number should be added to this form above the
                                signatures below before the issuing of any payment instruction and communicated directly
                                after having been completed. If the date of the
                                payment instruction falls on a non-processing day (weekend or public holiday) I agree
                                that the payment instruction may be debited against
                                my account on the following business day; or subsequent payment instructions will
                                continue to be delivered in terms of this authority until
                                the obligations in terms of the Agreement have been paid or until this authority is
                                cancelled by me/us by giving you notice in writing of not
                                less than one calendar month in writing.
                            </p>
                            <p class="mb-5">
                                <span class="font-bold">B. MANDATE:</span>
                                I/we acknowledge that all payment instructions issued by you shall be treated by my/our
                                above mentioned bank as if the instructions had
                                been issued by me/us personally.
                            </p>
                            <p class="mb-5">
                                <span class="font-bold">C. INCREASES & ADDITIONAL USERS & SMS CREDITS:</span>
                                I/we acknowledge that my/our debit order amount will increase annually with the
                                percentage specified in the details section above. I also
                                agree that when I request additional user licences they will form part of this mandate
                                and my debit order amount will be increased
                                according to the number of users I have requested.
                                I also agree that any SMS credits I use will be collected along with the following month's debit order
                                at the price per SMS credit specified in the details section above.
                            </p>
                            <p class="mb-5">
                                <span class="font-bold">D. CANCELLATION:</span>
                                I/we agree that although this authority and mandate may be cancelled by me/us, such
                                cancellation will not cancel the Agreement. I/we also
                                understand that I/we cannot reclaim amounts, which have been withdrawn from my/our
                                account (paid) in terms of this authority and
                                mandate if such amounts were legally owing to you. My subscription and debit order can
                                be cancelled at any time by providing one
                                calendar month's written notice.
                            </p>
                            <p class="mb-5">
                                <span class="font-bold">E. ASSIGNMENT:</span>
                                I/We acknowledge that this authority may be ceded or assigned to a third party if the
                                Agreement is also ceded or assigned to that third party, but in the absence of such
                                assignment of the Agreement, this Authority and Mandate cannot be assigned to any third party.
                            </p>
                            <p class="mb-5">
                                <span class="font-bold">F: OPT IN FOR SYSTEM COMMUNICATION:</span>
                                I/We acknowledge that any user I/We register on our profile is opted in and has given
                                consent to receive System notifications (Emails &
                                SMSs) related to downtime, maintenance, upgrades, or new features or resources that
                                become available.
                            </p>
                            <div class="form-group mt-4">
                                <label>Your Full Name</label>
                                <input type="text" class="form-control"
                                       placeholder="John Doe"
                                       v-model="form.signatory_name"
                                       :disabled="form.busy"
                                       :class="{'is-invalid': form.errors.has('signatory_name')}">
                                <span class="invalid-feedback" v-show="form.errors.has('signatory_name')">
                                        {{ form.errors.get("signatory_name") }}
                                </span>
                            </div>
                            <div class="form-group mt-1">
                                <label>ID Number</label>
                                <input type="text" class="form-control"
                                       placeholder="8009010000123"
                                       :disabled="form.busy"
                                       v-model="form.signatory_id"
                                       :class="{'is-invalid': form.errors.has('signatory_id')}">
                                <span class="invalid-feedback" v-show="form.errors.has('signatory_id')">
                                        {{ form.errors.get("signatory_id") }}
                                </span>
                            </div>
                            <div class="form-group mt-1">
                                <label>Email</label>
                                <input type="email" class="form-control"
                                       placeholder="you@yourco.com"
                                       :disabled="true"
                                       :value="signatoryEmail">
                            </div>

                            <div class="form-group mt-1">
                                <label>Mobile Number</label>
                                <input type="text" class="form-control"
                                       placeholder="0820001111"
                                       :disabled="form.busy"
                                       v-model="form.signatory_mobile"
                                       :class="{'is-invalid': form.errors.has('signatory_mobile')}">
                                <span class="invalid-feedback" v-show="form.errors.has('signatory_mobile')">
                                        {{ form.errors.get("signatory_mobile") }}
                                </span>
                            </div>

                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input"
                                       :disabled="form.busy"
                                       v-model="form.authorize_debit_order">
                                <span class="custom-control-label">
                                    I/We hereby confirm that I/We have full authority to sign on behalf of the company / close corporation and accept the terms as stated above.
                                </span>
                            </label>
                            <span class="text-danger mt-3" v-show="form.errors.has('authorize_debit_order')">
                                    {{ form.errors.get("authorize_debit_order") }}
                            </span>
                        </div>

                        <div class="form-group mt-4">
                            <label class="font-weight-bold">Acceptance of RedRabbit.zone Terms & Conditions</label>
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input"
                                       :disabled="form.busy"
                                       v-model="form.accept_terms">
                                <span class="custom-control-label">I accept the <a href="/legal"
                                                                                   target="_blank">Terms of service</a> and the <a
                                    href="/legal/privacy" target="_blank">Privacy Policy</a>.
                                    </span>
                            </label>
                            <span class="text-danger mt-3" v-show="form.errors.has('accept_terms')">
                                    {{ form.errors.get("accept_terms") }}
                            </span>
                        </div>

                        <div class="form-group mt-4">
                            <button class="btn btn-primary" @click.prevent="requestOTP()">
                                {{form.busy ? "Processing..." : "Authorize"}}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    export default {

        props: ["team", "token", "authRequestToken", "signatoryEmail", "subscriptionVariables", "isUpgrading"],

        data () {
            return {

                form: new AppForm({
                    debit_order_auth_request: this.authRequestToken,
                    signatory_mobile: null,
                }),

                settings: JSON.parse(this.subscriptionVariables),

                otpValidated: false
            };
        },

        computed: {

            escalationDate () {
                return moment(this.settings.escalation_date, "DD-MM").format("DD MMMM");
            },

            smsCost () {
                return _.round(100 * this.settings.sms_cost, 2).toFixed(2);
            },

            subscriptionMonth () {
                return moment(this.settings.subscription_date).format("MMMM YYYY");
            },

            firstCollectionDate () {
                return moment(this.settings.first_collection_date).format("DD MMM YYYY");
            }

        },

        methods: {

            getFormattedSubscriptionPlanName () {
                switch (this.settings.pricing_plan) {
                    case "premium":
                        return "Premium Plan";
                    case "limited":
                        return "Limited Plan";
                    default:
                        return "PremiumPlus Plan";
                }
            },

            requestOTP () {

                // Remove otp attribute for the otp request so that server side validation doesn't fail
                delete (this.form.otp);
                let self = this;
                App.post("/onboarding/debitorder/" + this.token + "/get-otp", this.form)
                .then(() => {

                    swal({
                        title: "Authorize Debit Order",
                        text: "Enter the One Time Pin sent to " + this.form.signatory_mobile,
                        input: "text",
                        showCancelButton: true,
                        inputValidator: (value) => {
                            if (!value) {
                                return "You did not enter the OTP!";
                            }
                        }
                    }).then((result) => {
                        if (result.value) {
                            self.authorize(result.value);
                        }
                    });

                });

            },

            authorize (otp) {
                this.form.otp = otp;

                App.post("/onboarding/debitorder/" + this.token + "/authorize", this.form)
                .then(() => {
                    swal(
                        "Debit order collection authorized!",
                        "Your subscription has been activated.",
                        "success"
                    ).then(() => {
                        window.location = "/";
                    });
                }).catch(() => {
                    toastr.error("Invalid otp provided");
                });
            }
        }
    };

</script>
